import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type DeleteCommentInput = {
  predictionMarketId: string;
  commentId: string;
};

const fetcher = async (
  _url: string,
  { arg: { predictionMarketId, commentId } }: { arg: DeleteCommentInput },
): Promise<void> => {
  const headers = authHeader.getOrThrow();
  await romanApi.delete(`/prediction-market/${predictionMarketId}/comments/${commentId}`, { headers });
};

export const useDeleteComment = (
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, DeleteCommentInput, void>,
) => {
  const { trigger, isMutating, error, data } = useSWRMutation(
    "/prediction-market/comments/delete",
    fetcher,
    swrOptions,
  );

  return {
    deleteComment: trigger,
    isMutating,
    error,
    data,
  };
};
